import React from 'react';
import { useNavigate, useLocation } from 'react-router';
import { makeStyles } from '@mui/styles';
import {
  ListItem,
  ListItemIcon,
  ListItemText
} from '@mui/material';
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';

const useStyles = makeStyles((theme) => ({
  listItem: {
    color: theme.palette.primary.main,
  },
}));

const Statistics = ({ data }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const classes = useStyles();

  return (
    <ListItem
      button
      onClick={() => {
        const pathname = location.pathname.endsWith('/')
          ? `${location.pathname}information/${data.id}`
          : `${location.pathname}/information/${data.id}`;
        navigate(`${pathname}${location.search}`);
      }}
    >
      <ListItemIcon className={classes.listItem}><SignalCellularAltIcon /></ListItemIcon>
      <ListItemText primary="Statistics" />
    </ListItem>
  );
};

export default Statistics;
